export const LOG_LEVELS = {
  error: 'Error',
};

export const REDIRECT_TYPES = {
  absolute: 'absolute',
  relative: 'relative',
  replace: 'replace',
};
